// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// import MintUI from 'mint-ui'
// import 'mint-ui/lib/style.css'
import 'lib-flexible/flexible'
import router from './router'
import './assets/css/base.css'
// import './assets/css/color.scss'
// import './config/rem.js'
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp'];
import { getDegreeCategory, fenToYuan, yuanToFen } from '@/utils/global';
Vue.prototype.$getDegreeCategory = getDegreeCategory;
// 全局注册分转元，元转分
Vue.prototype.$fenToYuan = fenToYuan;
Vue.prototype.$yuanToFen = yuanToFen;

// Vue.use(MintUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js